export default function Col({ tag: Tag = "article", className, children, ...props }) {
  return (
    <Tag {...props} className={className || "element _col"}>
      {children}
    </Tag>
  );
}
